import { useState } from 'react';
// import { useTranslation } from 'react-i18next';

//Components

import MenuHeaderMobile from '../MenuHeaderMobile';

// Images
import LOGO from '../../images/sign/logo.png';

// Styles
import styles from './index.module.sass';

export default function HeaderMX({ history, match }) {
  const [open, setOpen] = useState(false);
  return (
    <div className={`${styles.header}`}>
      <MenuHeaderMobile open={open} setOpen={setOpen} />

      <div className={styles.logo}>
        <img src={LOGO} alt='logo' />
      </div>

      <div className={styles.logo}></div>
    </div>
  );
}
